import React from 'react';
import { observer } from 'mobx-react';


// Translations
import translate from '../Translate.js';

const PermittedItems = observer(class PermittedItems extends React.Component {
  renderCalculator = calculatorType => {
    const { SessionStore } = this.props.store;

    SessionStore.calculator = calculatorType;
  }

  renderItems() {
    const { configuration, exam, pushLeft, translation } = this.props;
    const { examSession } = exam;

    let className = '';

    if(!pushLeft) {
      className = 'tooltip tooltip--right';
    } else {
      className = 'tooltip';
    }

    return [
      <strong key={0} className={this.props.compact ? '' : 'subtitle'}>
        {translation.allowed_items}
      </strong>,

      <ul key={1} className="data--comma">
        {configuration.permittedBathroomBreak &&
          <li>
            <span
              {...(configuration.permittedBathroomBreakInformation && {
                'aria-describedby': 'bathroom-tooltip'
              })}
            >
              {translation.bathroomBreak}

              {configuration.permittedBathroomBreakInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="bathroom-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedBathroomBreakInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedBlankPaper &&
          <li>
            <span
              {...(configuration.permittedBlankPaperInformation && {
                'aria-describedby': 'paper-tooltip'
              })}
            >
              {translation.blankPaper}

              {configuration.permittedBlankPaperInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="paper-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedBlankPaperInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedCalculator &&
          <li>
            <span
              {...(configuration.permittedCalculatorInformation && {
                'aria-describedby': 'calculator-tooltip'
              })}
            >
              {translation.calculator}

              {configuration.permittedCalculatorInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="calculator-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedCalculatorInformation}
                  </div>
                </div>
              } {
                configuration.virtualCalculatorType &&
                examSession &&
                (
                  examSession.status === 'Needs Proctor' ||
                  (
                    examSession.status === 'Scheduled' &&
                    examSession.location &&
                    (
                      examSession.location.workflowModule === 'automated' ||
                      examSession.location.workflowModule === 'hybrid' ||
                      examSession.location.workflowModule === 'hybrid-scheduling'
                    )
                  )
                ) &&

                <button
                  className="btn--link"
                  onClick={() => this.renderCalculator(configuration.virtualCalculatorType)}
                  type="button"
                >
                  {translation.test_calculator}
                </button>
              }
            </span>
          </li>
        }

        {configuration.permittedDictionary &&
          <li>
            <span
              {...(configuration.permittedDictionaryInformation && {
                'aria-describedby': 'dictionary-tooltip'
              })}
            >
              {translation.dictionary}

              {configuration.permittedDictionaryInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="dictionary-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedDictionaryInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedEarplugs &&
          <li>
            <span
              {...(configuration.permittedEarplugsInformation && {
                'aria-describedby': 'earplugs-tooltip'
              })}
            >
              {translation.earplugs}

              {configuration.permittedEarplugsInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="earplugs-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedEarplugsInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedFormulaSheet &&
          <li>
            <span
              {...(configuration.permittedFormulaSheetInformation && {
                'aria-describedby': 'formula-tooltip'
              })}
            >
              {translation.formulaSheet}

              {configuration.permittedFormulaSheetInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="formula-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedFormulaSheetInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedNotes &&
          <li>
            <span
              {...(configuration.permittedNotesInformation && {
                'aria-describedby': 'notes-tooltip'
              })}
            >
              {translation.notes}

              {configuration.permittedNotesInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="notes-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedNotesInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedTextbook &&
          <li>
            <span
              {...(configuration.permittedTextbookInformation && {
                'aria-describedby': 'textbook-tooltip'
              })}
            >
              {translation.textbook}

              {configuration.permittedTextbookInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="textbook-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedTextbookInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedWebsites &&
          <li>
            <span
              {...(configuration.permittedWebsitesInformation && {
                'aria-describedby': 'website-tooltip'
              })}
            >
              {translation.websites}

              {configuration.permittedWebsitesInformation &&
                <div className={className}>
                  <span className="tooltip__label" role="presentation" aria-hidden="true">
                    (?)
                  </span>

                  <div id="website-tooltip" className="tooltip__body" role="tooltip">
                    {configuration.permittedWebsitesInformation}
                  </div>
                </div>
              }
            </span>
          </li>
        }

        {configuration.permittedOtherItems &&
          <li className="allow-wrap">
            <span>{configuration.permittedOtherItems}</span>
          </li>
        }
      </ul>
    ]
  }

  renderDashboardItems() {
    const { configuration, exam, pushLeft, translation } = this.props;
    const { examSession } = exam;

    let className = '';

    if(!pushLeft) {
      className = 'tooltip tooltip--right';
    } else {
      className = 'tooltip';
    }

    return [
      <strong key={0} className={`panel__heading ${this.props.compact ? '' : 'strong-bold'}`}>
        <span>{translation.allowed_items}</span>
      </strong>,

      <div id="permitted-items-panel">
      <ul key={1} className="data__list--flex">
        {configuration.permittedBathroomBreak &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.bathroomBreak}</strong>

                <div className={className}>

                  <p id="bathroom-tooltip">
                    {configuration.permittedBathroomBreakInformation || translation.bathroomBreakInfo}
                  </p>
                </div>
            </span>
          </li>
        }

        {configuration.permittedBlankPaper &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.blankPaper}</strong>

                <div className={className}>

                  <p id="paper-tooltip">
                    {configuration.permittedBlankPaperInformation || translation.blankPaperInfo}
                  </p>
                </div>
            </span>
          </li>
        }

        {configuration.permittedCalculator &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.calculator}</strong>

                <div className={className}>

                  <p id="calculator-tooltip">
                    {configuration.permittedCalculatorInformation || translation.calculatorInfo}
                  </p>
                </div>
              {
              configuration.virtualCalculatorType &&
              examSession &&
              (
                examSession.status === 'Needs Proctor' ||
                (
                  examSession.status === 'Scheduled' &&
                  examSession.location &&
                  (
                    examSession.location.workflowModule === 'automated' ||
                    examSession.location.workflowModule === 'hybrid' ||
                    examSession.location.workflowModule === 'hybrid-scheduling'
                  )
                )
              ) &&

              <button
                className="btn--link"
                onClick={() => this.renderCalculator(configuration.virtualCalculatorType)}
                type="button"
              >
                {translation.test_calculator}
              </button>
            }
            </span>
          </li>
        }

        {configuration.permittedDictionary &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.dictionary}</strong>

                <div className={className}>

                  <p id="dictionary-tooltip">
                    {configuration.permittedDictionaryInformation || translation.dictionaryInfo}
                  </p>
                </div>
            </span>
          </li>
        }

        {configuration.permittedEarplugs &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.earplugs}</strong>

                <div className={className}>

                  <p id="earplugs-tooltip">
                    {configuration.permittedEarplugsInformation || translation.earplugInfo}
                  </p>
                </div>
            </span>
          </li>
        }

        {configuration.permittedFormulaSheet &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.formulaSheet}</strong>

                <div className={className}>

                  <p id="formula-tooltip">
                    {configuration.permittedFormulaSheetInformation || translation.formulaSheetInfo}
                  </p>
                </div>
            </span>
          </li>
        }

        {configuration.permittedNotes &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.notes}</strong>

                <div className={className}>

                  <div id="notes-tooltip">
                    {configuration.permittedNotesInformation || translation.notesInfo}
                  </div>
                </div>
            </span>
          </li>
        }

        {configuration.permittedTextbook &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.textbook}</strong>

                <div className={className}>

                  <div id="textbook-tooltip">
                    {configuration.permittedTextbookInformation || translation.textbookInfo}
                  </div>
                </div>
            </span>
          </li>
        }

        {configuration.permittedWebsites &&
          <li className="data__list-item--flex">
            <span>
              <strong>{translation.websites}</strong>

                <div className={className}>

                  <div id="website-tooltip">
                    {configuration.permittedWebsitesInformation || translation.websiteInfo}
                  </div>
                </div>
            </span>
          </li>
        }

        {configuration.permittedOtherItems &&
          <li className="allow-wrap data__list-item--flex">
            <span>
              <strong>{translation.otherItems}</strong>

              {configuration.permittedOtherItems &&
                <div className={className}>
                    {configuration.permittedOtherItems}
                </div>
              }
            </span>
          </li>
        }
      </ul>
      </div>
    ]
  }

  render() {
    const { configuration, listItem, dashboardView } = this.props;

    if(
      configuration.permittedBathroomBreak ||
      configuration.permittedBlankPaper ||
      configuration.permittedCalculator ||
      configuration.permittedDictionary ||
      configuration.permittedEarplugs ||
      configuration.permittedFormulaSheet ||
      configuration.permittedNotes ||
      configuration.permittedTextbook ||
      configuration.permittedWebsites ||
      configuration.permittedOtherItems
    ) {
      if(listItem) {
        return (
          <li className="data__list--full-width">
            {dashboardView ? this.renderDashboardItems() : this.renderItems()}
          </li>
        )
      } else {
        return (
          <div>
            {this.renderItems()}
          </div>
        )
      }
    }

    return null;
  }
})

export default translate('PermittedItems')(PermittedItems);



// WEBPACK FOOTER //
// ./src/app/components/Modules/PermittedItems.js